var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKlienci = function SvgKlienci(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12,0.1C9.3,0.1,7.2,2.3,7.2,5S9.3,9.8,12,9.8s4.8-2.2,4.8-4.8C16.8,2.3,14.7,0.1,12,0.1z M12,8.3 c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S13.8,8.3,12,8.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12,5.3c-1.7,0-3,1.3-3,3h1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5H15C15,6.7,13.6,5.3,12,5.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12,2.5c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2C14.2,3.4,13.2,2.5,12,2.5z M12,5.3 c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7C12.7,5,12.4,5.3,12,5.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.2,14.2c-2.7,0-4.8,2.2-4.8,4.8c0,2.7,2.2,4.8,4.8,4.8c2.7,0,4.8-2.2,4.8-4.8S21.8,14.2,19.2,14.2z  M19.2,22.4c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3C22.5,20.9,21,22.4,19.2,22.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.2,19.4c-1.7,0-3,1.3-3,3h1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5h1.5C22.2,20.8,20.8,19.4,19.2,19.4z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.2,16.5c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2C21.3,17.5,20.4,16.5,19.2,16.5z M19.2,19.4 c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7C19.9,19.1,19.5,19.4,19.2,19.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4.8,14.2C2.2,14.2,0,16.4,0,19s2.2,4.8,4.8,4.8c2.7,0,4.8-2.2,4.8-4.8S7.5,14.2,4.8,14.2z M4.8,22.4 c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3C8.2,20.9,6.7,22.4,4.8,22.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4.8,19.4c-1.7,0-3,1.3-3,3h1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5h1.5C7.8,20.8,6.5,19.4,4.8,19.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4.8,16.5c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S6,16.5,4.8,16.5z M4.8,19.4 c-0.4,0-0.7-0.3-0.7-0.7S4.5,18,4.8,18s0.7,0.3,0.7,0.7C5.5,19.1,5.2,19.4,4.8,19.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.8,15.1l-2.2-2.2c-0.3-0.3-0.8-0.3-1.1,0l-2.2,2.2c-0.3,0.3-0.3,0.8,0,1.1c0.3,0.3,0.8,0.3,1.1,0l1.7-1.7 l1.7,1.7c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2C15,15.8,15,15.4,14.8,15.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12,10.2c-0.4,0-0.7,0.3-0.7,0.7v2.5c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7V11C12.7,10.6,12.4,10.2,12,10.2 z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKlienci, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/klienci.bfd348a4.svg";
export { ForwardRef as ReactComponent };